module.exports = __webpack_public_path__ + "img/wangjun.3f350a1f.png";